export enum SortDirection {
    None = "none",
    Ascending = "asc",
    Descending = "desc"
}

export class SortArgs {

    sortDirection: SortDirection = SortDirection.None;
    sortProperty: string = "";

    constructor(direction: SortDirection, property: string) {
        this.sortDirection = direction;
        this.sortProperty = property;
    }
}

export interface SortOption {
    value: string;
    display: string;
}


export enum SortAttribute { //copied from Hyland.Unity.DocumentQuery.SortAttribute.  Do NOT alter these values!
    DocumentID = 1,
    DocumentName = 2,
    DocumentType = 3,
    DocumentDate = 4,
    ArchivalDate = 5,
    Institution = 6,
    AuthorID = 7,
    Batch = 8,
    RevisionCount = 9,
    DocumentTypeGroup = 10,
    DocumentTypeName = 11,
    AuthorName = 12,
    NoteContents = 13,
    NoteCount = 14,
    NoteTypeName = 15,
    WorkflowQueue = 16,
    ArrivalTime = 18
}